import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Cookies from "universal-cookie";
import Api from "../contexts/Api";
import { formatDate, getTranslate } from "../contexts/Utils";
import { useNotification } from "../components/UseNotification";
import ModalReview from "../components/ModalReview";
import { useState } from "react";
import ModalPrice from "../components/ModalPrice";
import ModalValidatePrice from "../components/ModalValidatePrice";
import Stars from "../components/Stars";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

const MissionView = (props) => {
  const { notification } = useNotification();
  const navigate = useNavigate();
  const cookies = new Cookies();
  const user = cookies.get('nudge_user');
  const role = user.role;

  const [modalData, setModalData] = useState({});
  const [cancelDialog, setCancelDialog] = useState(false);
  const [moreCat, setMoreCat] = useState(false);
  const { missions, setMissions, lang, currentMission, setCurrentMission, setMobileViewActive, getCategoriesRender } = props;

  const { gallery, totalReviews, avgScore, name, firstname, email, phone, mission_id, time_expert_assigned, title, status: missionStatus, categories: missionCat, content, time_online, deadlines, price
  } = missions[currentMission];
  const contentRender = { __html: JSON.parse(content)[lang] } || { __html: '' };

  // check if mission was assigned more than 3 days ago (so we can cancel it)
  let isMoreThanThreeDays = false;
  if (time_expert_assigned) {
    let threeDaysAfter = new Date(time_expert_assigned);
    threeDaysAfter.setDate(threeDaysAfter.getDate() + 3);

    isMoreThanThreeDays = new Date() > threeDaysAfter;
  }

  // check if expert is validated / user is not expert
  const expertAllowed = role === 2 && user.status === 2 && Boolean(user.account_confirmed);

  // 
  // ─── REMOVE A MISSION FROM THE LIST ───────────────────────────────────────
  //
  const removeMission = (id) => {
    let obj = { ...missions };
    delete obj[id];
    setMissions(obj);
    setCurrentMission(Object.keys(obj).length ? Object.keys(obj)[0] : '');
  }

  // 
  // ─── HANDLE APPLY TO A MISSION ───────────────────────────────────────
  //
  const handleApply = async (id) => {
    // datetime now for db
    const time_expert_assigned = new Date().toISOString().slice(0, 19).replace('T', ' ');

    const params = {
      data: { fields: { expert_id: user.user_id, status: 2, time_expert_assigned }, mission_id: id },
      endpoint: '/missions',
      method: 'PUT'
    };

    const missionApplied = await Api(params);

    const message = missionApplied.success ? getTranslate('mission_assigned', lang) : missionApplied.message
    notification({ variant: missionApplied.success ? 'success' : 'error', message: message });

    missionApplied.success && removeMission(id);
  }

  // 
  // ─── HANDLE CANCEL EXPERT / MISSION ───────────────────────────────────────
  //
  const handleCancel = async (id, deleted = false) => {
    let data;
    if (deleted) data = { mission_id: id, fields: { deleted: 1, status: 7 } }
    else {
      data = {
        fields: { status: 7 },
        mission_id: id
      }
    }

    const params = {
      data,
      endpoint: '/missions',
      method: 'PUT'
    };

    const missionApplied = await Api(params);

    const translation = deleted ? 'mission_deleted' : 'mission_canceled';
    const message = missionApplied.success ? getTranslate(translation, lang) : missionApplied.message
    notification({ variant: missionApplied.success ? 'success' : 'error', message: message });

    missionApplied.success && removeMission(id);
  }

  // 
  // ─── HANDLE FINISH MISSION ───────────────────────────────────────
  //
  const handleModal = (id, name, ended = true) => {
    setModalData({
      id,
      price,
      modalName: name,
      ended
    })
  }

  // 
  // ─── HANDLE REPORT TO BE VALIDATED BY THE PRO ───────────────────────────────────────
  //
  const handleReport = async (id) => {
    const params = {
      endpoint: '/missions',
      method: 'PUT',
      data: { fields: { status: 5 }, mission_id: id }
    }

    const query = await Api(params);
    const successMessage = getTranslate('mission_reported');
    notification({ variant: query.success ? 'success' : 'error', message: query.success ? successMessage : query.message });

    if (query.success) {
      // update current mission status
      setMissions(prev => {
        const obj = { ...prev };
        obj[id].status = 5;
        return obj;
      })

      // transaction query
      const obj = {
        expert_id: user.user_id,
        mission_id: currentMission,
        industrial_price: price,
      }

      const transactionParams = {
        endpoint: '/transactions',
        method: 'POST',
        data: { fields: obj }
      }

      await Api(transactionParams);
    }
  }

  // 
  // ─── HIDE MODALS ───────────────────────────────────────
  //
  const hideModals = () => {
    setModalData({})
  }

  const handleClose = (bool) => {
    setCancelDialog(bool)
  }

  return <S.Container>
    <S.Header>
      <div onClick={() => setMobileViewActive(false)}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M448 256C448 264.8 440.6 272 431.4 272H54.11l140.7 149.3c6.157 6.531 5.655 16.66-1.118 22.59C190.5 446.6 186.5 448 182.5 448c-4.505 0-9.009-1.75-12.28-5.25l-165.9-176c-5.752-6.094-5.752-15.41 0-21.5l165.9-176c6.19-6.562 16.69-7 23.45-1.094c6.773 5.938 7.275 16.06 1.118 22.59L54.11 240h377.3C440.6 240 448 247.2 448 256z" /></svg>
      </div>
      {title && <span className="title">{title}</span>}
      {time_online !== undefined && <span className="time">{formatDate({ time: time_online, display: 'date' })}</span>}
    </S.Header>
    {missionCat && Object.keys(missionCat).length &&
      <div className="categories">
        {getCategoriesRender(missionCat, moreCat)}
        {missionCat.length > 4 && <S.CatButton onClick={() => setMoreCat(prev => !prev)}>{moreCat ? '-' : '+'}</S.CatButton>}
      </div>
    }
    <S.Content>
      {content && <p className={`content ${missionStatus !== 1 ? 'border' : ''}`} dangerouslySetInnerHTML={contentRender}></p>}
      {deadlines && <div className="deadlines">
        <span>{getTranslate('deadline', lang)}</span>
        <span>{formatDate({ time: deadlines, display: 'date' })}</span>
      </div>}
      {missionStatus === 3 && price && <div className="deadlines">
        <span>{getTranslate(role === 1 ? 'proposed_price' : 'proposed_price_commission', lang)}</span>
        <span>{price}€ HT</span>
      </div>}
      {missionStatus >= 4 && price && <div className="deadlines">
        <span>{getTranslate(role === 1 ? 'price' : 'price_excluding_commission', lang)}</span>
        <span>{price}€ HT</span>
      </div>}
      {role !== 2 && time_expert_assigned && <S.User>
        <p>{getTranslate('expert_assigned')}</p>
        <div>
          <S.UserColumns>
            <span>{getTranslate('name', lang)}</span>
            <span>Email</span>
            <span>{getTranslate('tel', lang)}</span>
            {avgScore && <span>Score</span>}
            <span>{getTranslate('reviews_number', lang)}</span>
          </S.UserColumns>
          <div>
            <span>{firstname} {name}</span>
            <span>{email}</span>
            <span>{phone}</span>
            {avgScore && <span><Stars score={avgScore} /></span>}
            <span>{totalReviews || 0}</span>
          </div>
        </div>
      </S.User>}
      {Boolean(gallery && JSON.parse(gallery).length && missionStatus > 1) && <S.Files>
        <span>{getTranslate('files', lang)}</span>
        {JSON.parse(gallery).map(file => <a key={file} href={`https://nudge-app.agence-cactus.fr/file/missions/${mission_id}/${file}`} download><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M180.7 395.3C183.8 398.4 187.9 400 192 400s8.188-1.562 11.31-4.688l144-144c6.25-6.25 6.25-16.38 0-22.62s-16.38-6.25-22.62 0L208 345.4V48C208 39.16 200.8 32 192 32S176 39.16 176 48v297.4L59.31 228.7c-6.25-6.25-16.38-6.25-22.62 0s-6.25 16.38 0 22.62L180.7 395.3zM368 448h-352C7.156 448 0 455.2 0 464S7.156 480 16 480h352c8.844 0 16-7.156 16-16S376.8 448 368 448z" /></svg> {file}</a>)}
      </S.Files>
      }
    </S.Content>
    <S.FooterButtons>
      {missionStatus === 1 && role === 2 && expertAllowed &&
        <S.Button onClick={() => handleApply(mission_id)}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M64 480H258.5L257.4 484.2C255.1 493.6 255.7 503.2 258.8 512H64C28.65 512 0 483.3 0 448V64C0 28.65 28.65 0 64 0H220.1C232.8 0 245.1 5.057 254.1 14.06L369.9 129.9C378.9 138.9 384 151.2 384 163.9V299.6L352 331.6V192H240C213.5 192 192 170.5 192 144V32H64C46.33 32 32 46.33 32 64V448C32 465.7 46.33 480 64 480H64zM347.3 152.6L231.4 36.69C229.4 34.62 226.8 33.18 224 32.48V144C224 152.8 231.2 160 240 160H351.5C350.8 157.2 349.4 154.6 347.3 152.6zM473.3 241.4C492.1 222.6 522.4 222.6 541.2 241.4L558.5 258.7C577.2 277.4 577.2 307.8 558.5 326.5L404.1 480.1C398.8 486.2 391.1 490.6 382.7 492.7L307.9 511.4C302.4 512.8 296.6 511.2 292.7 507.2C288.7 503.2 287.1 497.4 288.5 491.1L307.2 417.2C309.3 408.8 313.6 401 319.8 394.9L473.3 241.4zM518.6 263.1C512.3 257.7 502.2 257.7 495.9 263.1L471.2 288.8L511.1 328.7L535.9 303.9C542.1 297.7 542.1 287.5 535.9 281.3L518.6 263.1zM338.2 424.1L325.1 473.9L374.9 461.6C377.7 460.9 380.3 459.5 382.3 457.4L488.5 351.3L448.5 311.4L342.4 417.5C340.4 419.6 338.9 422.1 338.2 424.1L338.2 424.1z" /></svg>
          <span>{getTranslate('apply', lang)}</span>
        </S.Button>}
      {[2, 3, 4].includes(missionStatus) && role === 1 && isMoreThanThreeDays && <>
        <S.Button color="warning">
          <svg onClick={() => handleModal(mission_id, 'review', false)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M320 32c61.76 0 112 50.24 112 112c0 34.85-16.33 65.64-41.37 86.2l25.62 20.22c29.12-26.35 47.75-64.06 47.75-106.4c0-79.53-64.47-143.1-143.1-143.1c-54.45 0-101.3 30.58-125.7 75.16l25.4 20.05C237.9 57.95 275.8 32 320 32zM96 480c0-70.58 57.42-128 128-128h114.3L297.8 320l-73.78 .0006c-88.36 0-160 71.63-160 159.1C63.1 497.7 78.33 512 95.1 512h444.1l-40.53-32H96zM633.9 483.4l-608-480c-6.938-5.453-17-4.25-22.48 2.641c-5.469 6.938-4.281 17 2.641 22.48l608 480C617 510.9 620.5 512 623.1 512c4.734 0 9.422-2.094 12.58-6.078C642 498.1 640.8 488.9 633.9 483.4z" /></svg>
          <span>{getTranslate('cancel_expert', lang)}</span>
        </S.Button>
        <S.Button color="error" mr="auto">
          <svg onClick={() => handleCancel(mission_id)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M315.3 411.3c-6.253 6.253-16.37 6.253-22.63 0L160 278.6l-132.7 132.7c-6.253 6.253-16.37 6.253-22.63 0c-6.253-6.253-6.253-16.37 0-22.63L137.4 256L4.69 123.3c-6.253-6.253-6.253-16.37 0-22.63c6.253-6.253 16.37-6.253 22.63 0L160 233.4l132.7-132.7c6.253-6.253 16.37-6.253 22.63 0c6.253 6.253 6.253 16.37 0 22.63L182.6 256l132.7 132.7C321.6 394.9 321.6 405.1 315.3 411.3z" /></svg>
          <span>{getTranslate('cancel_mission', lang)}</span>
        </S.Button>
      </>}
      {missionStatus === 2 && role === 1 && <S.Button sr={true} ml='auto'>
        <svg onClick={() => handleModal(mission_id, 'price')} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M512 96H64C46.33 96 32 110.3 32 128V384C32 401.7 46.33 416 64 416H338.2L330.2 448H64C28.65 448 0 419.3 0 384V128C0 92.65 28.65 64 64 64H512C547.3 64 576 92.65 576 128V192C565.1 191.7 554.2 193.6 544 197.6V128C544 110.3 529.7 96 512 96V96zM256 304C256 295.2 263.2 288 272 288H368C376.8 288 384 295.2 384 304C384 312.8 376.8 320 368 320H272C263.2 320 256 312.8 256 304zM464 192C472.8 192 480 199.2 480 208C480 216.8 472.8 224 464 224H272C263.2 224 256 216.8 256 208C256 199.2 263.2 192 272 192H464zM143.1 144C152.8 144 159.1 151.2 159.1 160V169.6C165.9 170.6 178.1 173.2 184.1 174.5C192.7 176.8 197.7 185.6 195.5 194.1C193.2 202.7 184.4 207.7 175.9 205.5C171.9 204.4 158.2 201.7 153.8 201C140.9 199 130.1 200.6 122.9 203.9C115.7 207.2 112.1 211.4 112.4 214.1C111.7 219.1 112.3 221.2 112.9 222.4C113.5 223.8 114.8 225.5 117.8 227.5C124.6 232.1 134.9 235.3 148.8 239.5L149.4 239.7C161.7 243.4 177.3 248.1 188.9 256.5C195.1 261.1 200.9 267.1 204.5 275.3C208.1 283.6 208.8 292.8 207.2 302.5C204.1 319.1 192.6 331.9 177.9 338.2C172.3 340.6 166.3 342.2 160 343.1V352C160 360.8 152.8 368 144 368C135.2 368 128 360.8 128 352V342.4C118.6 340.6 104.5 335.8 95.55 332.7C93.79 332.1 92.22 331.6 90.95 331.2C82.56 328.4 78.03 319.3 80.82 310.9C83.61 302.6 92.67 298 101.1 300.8C102.1 301.5 105 302.2 107.2 302.9C116.7 306.1 127.9 309.9 134.3 310.1C147.6 313.1 158.3 311.8 165.3 308.8C171.8 306 174.7 302.1 175.6 297C176.4 292.4 175.8 289.7 175.1 288.1C174.4 286.4 172.9 284.5 170 282.4C163.5 277.6 153.3 274.3 139.6 270.1L137.5 269.5C125.7 265.9 110.9 261.5 99.87 254C93.65 249.8 87.7 244 83.93 236.1C80.1 228 79.2 219 80.85 209.5C83.73 192.8 95.57 181.2 109.7 174.8C115.3 172.2 121.5 170.4 128 169.3V160C128 151.2 135.2 144 144 144H143.1zM537.5 241.4C556.3 222.6 586.7 222.6 605.4 241.4L622.8 258.7C641.5 277.5 641.5 307.9 622.8 326.6L469.1 480.3C462.9 486.5 455.2 490.8 446.8 492.1L371.9 511.7C366.4 513 360.7 511.4 356.7 507.5C352.7 503.5 351.1 497.7 352.5 492.3L371.2 417.4C373.3 408.9 377.7 401.2 383.8 395.1L537.5 241.4zM582.8 264C576.5 257.8 566.4 257.8 560.2 264L535.3 288.8L575.3 328.8L600.2 303.1C606.4 297.7 606.4 287.6 600.2 281.4L582.8 264zM402.2 425.1L389.1 474.2L439 461.9C441.8 461.2 444.4 459.8 446.4 457.7L552.7 351.4L512.7 311.5L406.5 417.7C404.4 419.8 402.9 422.3 402.2 425.1L402.2 425.1z" /></svg>
        <span>{getTranslate('set_price', lang)}</span>
      </S.Button>}
      {missionStatus === 3 && role === 2 && <S.Button sr={true} ml='auto'>
        <svg onClick={() => handleModal(mission_id, 'validate_price')} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M464 288C472.8 288 480 295.2 480 304C480 312.8 472.8 320 464 320H272C263.2 320 256 312.8 256 304C256 295.2 263.2 288 272 288H464zM256 208C256 199.2 263.2 192 272 192H464C472.8 192 480 199.2 480 208C480 216.8 472.8 224 464 224H272C263.2 224 256 216.8 256 208zM159.1 169.6C165.9 170.6 178.1 173.2 184.1 174.5C192.7 176.8 197.7 185.6 195.5 194.1C193.2 202.7 184.4 207.7 175.9 205.5C171.9 204.4 158.2 201.7 153.8 201C140.9 199 130.1 200.6 122.9 203.9C115.7 207.2 112.1 211.4 112.4 214.1C111.7 219.1 112.3 221.2 112.9 222.4C113.5 223.8 114.8 225.5 117.8 227.5C124.6 232.1 134.9 235.3 148.8 239.5L149.4 239.7C161.7 243.4 177.3 248.1 188.9 256.5C195.1 261.1 200.9 267.1 204.5 275.3C208.1 283.6 208.8 292.8 207.2 302.5C204.1 319.1 192.6 331.9 177.9 338.2C172.3 340.6 166.3 342.2 160 343.1V352C160 360.8 152.8 368 144 368C135.2 368 128 360.8 128 352V342.4C118.6 340.6 104.4 335.8 95.55 332.7C93.78 332.1 92.22 331.6 90.95 331.2C82.56 328.4 78.03 319.3 80.82 310.9C83.61 302.6 92.67 298 101.1 300.8C102.1 301.5 105.1 302.2 107.2 302.9C116.7 306.1 127.9 309.9 134.3 310.1C147.6 313.1 158.3 311.8 165.3 308.8C171.8 306 174.7 302.1 175.6 297C176.4 292.4 175.8 289.7 175.1 288.1C174.4 286.4 172.9 284.5 170 282.4C163.5 277.6 153.3 274.3 139.6 270.1L137.5 269.5C125.7 265.9 110.9 261.5 99.87 254C93.65 249.8 87.7 244 83.93 236.1C80.1 228 79.2 219 80.85 209.5C83.73 192.8 95.57 181.2 109.7 174.8C115.3 172.2 121.5 170.4 128 169.3V160C128 151.2 135.2 144 144 144C152.8 144 160 151.2 160 160L159.1 169.6zM0 128C0 92.65 28.65 64 64 64H512C547.3 64 576 92.65 576 128V384C576 419.3 547.3 448 512 448H64C28.65 448 0 419.3 0 384V128zM32 128V384C32 401.7 46.33 416 64 416H512C529.7 416 544 401.7 544 384V128C544 110.3 529.7 96 512 96H64C46.33 96 32 110.3 32 128z" /></svg>
        <span>{getTranslate('see_price', lang)}</span>
      </S.Button>}
      {missionStatus === 4 && role === 2 && <S.Button sr={true} ml='auto'>
        <svg onClick={() => handleClose(true)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M443.3 100.7C449.6 106.9 449.6 117.1 443.3 123.3L171.3 395.3C165.1 401.6 154.9 401.6 148.7 395.3L4.686 251.3C-1.562 245.1-1.562 234.9 4.686 228.7C10.93 222.4 21.06 222.4 27.31 228.7L160 361.4L420.7 100.7C426.9 94.44 437.1 94.44 443.3 100.7H443.3z" /></svg>
        <span>{getTranslate('request_processed', lang)}</span>
      </S.Button>}
      {missionStatus === 5 && role === 1 && <S.Button sr={true} ml='auto'>
        <svg onClick={() => handleModal(mission_id, 'review')} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M443.3 100.7C449.6 106.9 449.6 117.1 443.3 123.3L171.3 395.3C165.1 401.6 154.9 401.6 148.7 395.3L4.686 251.3C-1.562 245.1-1.562 234.9 4.686 228.7C10.93 222.4 21.06 222.4 27.31 228.7L160 361.4L420.7 100.7C426.9 94.44 437.1 94.44 443.3 100.7H443.3z" /></svg>
        <span>{getTranslate('rate_expert', lang)}</span>
      </S.Button>}
      {missionStatus === 1 && role !== 2 && <>
        <S.Button>
          <svg onClick={() => navigate(`/missions/editer/${mission_id}`)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M386.7 22.63C411.7-2.365 452.3-2.365 477.3 22.63L489.4 34.74C514.4 59.74 514.4 100.3 489.4 125.3L269 345.6C260.6 354.1 249.9 359.1 238.2 362.7L147.6 383.6C142.2 384.8 136.6 383.2 132.7 379.3C128.8 375.4 127.2 369.8 128.4 364.4L149.3 273.8C152 262.1 157.9 251.4 166.4 242.1L386.7 22.63zM454.6 45.26C442.1 32.76 421.9 32.76 409.4 45.26L382.6 72L440 129.4L466.7 102.6C479.2 90.13 479.2 69.87 466.7 57.37L454.6 45.26zM180.5 281L165.3 346.7L230.1 331.5C236.8 330.2 242.2 327.2 246.4 322.1L417.4 152L360 94.63L189 265.6C184.8 269.8 181.8 275.2 180.5 281V281zM208 64C216.8 64 224 71.16 224 80C224 88.84 216.8 96 208 96H80C53.49 96 32 117.5 32 144V432C32 458.5 53.49 480 80 480H368C394.5 480 416 458.5 416 432V304C416 295.2 423.2 288 432 288C440.8 288 448 295.2 448 304V432C448 476.2 412.2 512 368 512H80C35.82 512 0 476.2 0 432V144C0 99.82 35.82 64 80 64H208z" /></svg>
          <span>{getTranslate('edit', lang)}</span>
        </S.Button>
        <S.Button color="error" sr={true}>
          <svg onClick={() => handleCancel(mission_id, true)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M432 64C440.8 64 448 71.16 448 80C448 88.84 440.8 96 432 96H413.7L388.2 452.6C385.9 486.1 357.1 512 324.4 512H123.6C90.01 512 62.15 486.1 59.75 452.6L34.29 96H16C7.164 96 0 88.84 0 80C0 71.16 7.164 64 16 64H111.1L137 22.56C145.8 8.526 161.2 0 177.7 0H270.3C286.8 0 302.2 8.526 310.1 22.56L336.9 64H432zM177.7 32C172.2 32 167.1 34.84 164.2 39.52L148.9 64H299.1L283.8 39.52C280.9 34.84 275.8 32 270.3 32H177.7zM381.6 96H66.37L91.67 450.3C92.87 467 106.8 480 123.6 480H324.4C341.2 480 355.1 467 356.3 450.3L381.6 96z" /></svg>
          <span>{getTranslate('delete', lang)}</span>
        </S.Button>
      </>}
    </S.FooterButtons>
    {
      Boolean(Object.keys(modalData).length) && modalData.modalName === 'review' &&
      <ModalReview data={modalData} setModalData={setModalData} setMissions={setMissions} setCurrentMission={setCurrentMission} />
    }
    {
      Boolean(Object.keys(modalData).length) && modalData.modalName === 'price' &&
      <ModalPrice data={modalData} setModalData={setModalData} setMissions={setMissions} />
    }
    {
      Boolean(Object.keys(modalData).length) && modalData.modalName === 'validate_price' &&
      <ModalValidatePrice data={modalData} setModalData={setModalData} setMissions={setMissions} />
    }
    {Boolean(Object.keys(modalData).length) && <S.ModalBackground onClick={hideModals} />}
    <Dialog
      open={cancelDialog}
      onClose={() => handleClose()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Clôturer la mission
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">Êtes-vous sûr de vouloir clôturer la mission ?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose()} color="error">Annuler</Button>
        <Button
          onClick={() => {
            handleReport(mission_id)
            handleClose(false);
          }}
          autoFocus
          variant="contained"
        >
          Confirmer
        </Button>
      </DialogActions>
    </Dialog>
  </S.Container >
}

export default MissionView;

const S = {}
S.Container = styled.div`
  display: flex;
  flex-direction: column;
  height: fit-content;
  min-height: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  position: relative;

  & .categories {
    margin-top: 15px;
    display: flex;
    gap: 8px;
    margin-bottom: 15px;
    flex-wrap: wrap;

    & > span {
      border-radius: 30px;
      background: ${({ theme }) => theme.title};
      color: ${({ theme }) => theme.textInverse};
      font-size: 12px;
      font-weight: bold;
      padding: 4px 11px;
    }
  }
  & .content {
    font-size: 14px;
    font-weight: lighter;
    margin: 0;

    & p {
      margin: 0;
    }

    &.border {
      padding-bottom: 20px;
      border-bottom: solid 0.5px #7B7B7B;
    }
  }
  & .deadlines {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-bottom: 20px;
    margin-top: 20px;

    // title
    & > span:first-child {
      text-transform: uppercase;
      font-size: 12px;
      color: ${({ theme }) => theme.title}
    }
    // value
    & > span:last-child {
      font-size: 15px;
      font-weight: bold;
    }
  }

  @media(max-width: 850px) {
    & > svg {
      display: block;
    }
  }
`

S.CatButton = styled.button`
  background: ${({ theme }) => theme.linear};
  border-radius: 50%;
  border: none;
  width: 25px;
  height: 25px;
  color: #fff;
  cursor: pointer;
`

S.Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  & > div {
    width: 100%;
    margin-bottom: 15px;

    & > svg {
      display: block;
      width: 20px;
      min-width: 20px;
      height: 20px;
      fill: ${({ theme }) => theme.text};

      @media(min-width: 850px) {
        display: none;
      }
    }
  }
  & .title {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  & .time {
    font-size: 12px;
    color: #B4B4B4;
  }
`

S.Button = styled.div`
  display: flex;
  justify-content: center;
  margin-top: auto;
  margin-left: ${({ mr, ml }) => mr ? '15px' : ml ? ml : 'unset'};
  margin-right: ${({ mr }) => mr ? mr : 'unset'};
  position: relative;
  border-radius: 50%;
  width: fit-content;
  background: ${({ color, theme }) => {
    switch (color) {
      case 'success': return theme.linear;
      case 'error': return theme.red;
      case 'warning': return theme.orange;
      default: return theme.linear;
    }
  }};

  &:hover span {
    opacity: 1;
  }
  & svg {
    width: 20px;
    height: 20px;
    fill: #fff;
    cursor: pointer;
    padding: 10px;
  }
  & span {
    opacity: 0;
    position: absolute;
    color: ${({ theme }) => theme.text};
    border-radius: 5px;
    background: ${({ theme }) => theme.card};
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    padding: 3px 8px;
    font-size: 13px;
    bottom: calc(100% + 10px);
    left: ${({ sr }) => sr ? 'unset' : '0'};
    right: ${({ sr }) => sr ? '0' : 'unset'};
    transition: .3s;
    font-weight: lighter;
    white-space: nowrap;
    z-index: 10;

    @media(max-width: 1100px) {
      display: none;
    }
  }
`

S.FooterButtons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  margin-top: 16px;
`

S.User = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  margin-top: 20px;

  & > div {
    display: flex;
  }
  & p {
    text-transform: uppercase;
    font-size: 12px;
    margin: 0;
    margin-bottom: 10px;
    color: ${({ theme }) => theme.title}
  }
  & span {
    font-weight: lighter;
    font-size: 14px;
    height: 25px;
    display: flex;
    align-items: center;
  }
`

S.UserColumns = styled.div`
  display: flex;
  flex-direction: column;
  width: max-content;
  margin-right: 20px;

  & span {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 13px;
    height: 25px;
    display: flex;
    align-items: center;
  }
`

S.ModalBackground = styled.div`
  position: fixed;
  z-index: 9;
  background: #0000004a;
  inset: 0;
`

S.Files = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 20px;

  & > a {
    width: fit-content;
    padding: 4px 10px;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.text};
    gap: 10px;
    font-weight: lighter;
    background: #00000069;
    border-radius: 5px;
    font-size: 14.5px;
    transition: .3s;

    &:hover {
      background: #00000091;
    }
    & svg {
      fill: ${({ theme }) => theme.text};
      width: 14px;
    }
  }

  & span {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 13px;
    height: 25px;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.title};
  }
`

S.Content = styled.div`
  overflow-y: auto;
  height: 100%;
`